import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const tierStyle = {
  PLATINUM: {
    badge: "bg-gradient-to-r from-[#BF953F] to-[#FBF5B7] text-black",
    border: "border-[#BF953F]/50",
    accent: "text-[#FCF6BA]",
  },
  GOLD: {
    badge: "bg-pshl-gold text-black",
    border: "border-pshl-gold/40",
    accent: "text-pshl-gold",
  },
  SILVER: {
    badge: "bg-pshl-silver text-black",
    border: "border-white/20",
    accent: "text-pshl-silver",
  },
};

export default function SponsorPackageCard({ pkg, index = 0, onCta }) {
  const s = tierStyle[pkg.tier] || tierStyle.SILVER;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.45, delay: index * 0.05, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -4 }}
      data-testid={`sponsor-card-${pkg.id}`}
      className={`relative bg-pshl-surface border ${s.border} p-6 flex flex-col`}
    >
      <div className="flex items-center justify-between">
        <span className={`inline-block px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] font-display font-semibold ${s.badge}`}>
          {pkg.tier}
        </span>
        <span className="text-[10px] uppercase tracking-[0.22em] text-white/55">{pkg.price_band}</span>
      </div>

      <h3 className="font-display text-2xl text-white mt-5 leading-tight">{pkg.name}</h3>
      <div className={`mt-1 text-xs uppercase tracking-[0.22em] ${s.accent}`}>PSHL8 Partnership Track</div>

      <ul className="mt-5 space-y-2.5 text-sm text-white/80 flex-1">
        {pkg.benefits.map((b) => (
          <li key={b} className="flex items-start gap-2">
            <Check className={`h-4 w-4 mt-0.5 shrink-0 ${s.accent}`} />
            <span>{b}</span>
          </li>
        ))}
      </ul>

      <button
        data-testid={`sponsor-cta-${pkg.id}`}
        onClick={() => onCta?.(pkg)}
        className="mt-6 inline-flex items-center justify-center gap-2 bg-pshl-electric hover:bg-pshl-electric/90 text-white font-display uppercase tracking-[0.18em] text-xs px-5 py-3 transition-all hover:shadow-[0_0_24px_rgba(0,85,255,0.4)]"
      >
        Request Partnership Call
      </button>
    </motion.div>
  );
}
